document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector("[data-slider]");
  if (!slider) return;

  const track = slider.querySelector("[data-track]");
  const slides = slider.querySelectorAll("[data-slide]");
  const prevBtn = slider.querySelector("[data-prev]");
  const nextBtn = slider.querySelector("[data-next]");
  const dotsContainer = document.querySelector("[data-dots]");
  const dots = dotsContainer ? dotsContainer.querySelectorAll("button") : [];

  let current = 0;
  const total = slides.length;
  let autoPlayInterval;
  const AUTO_PLAY_TIME = 7000; // 7 segundos

  function showSlide(index) {
    track.style.transform = `translateX(-${index * 100}%)`;
    current = index;

    dots.forEach((dot, i) => {
      if (i === index) {
        dot.classList.add("bg-brand-color");
        dot.classList.remove("bg-red-300");
      } else {
        dot.classList.remove("bg-brand-color");
        dot.classList.add("bg-red-300");
      }
    });
  }

  function startAutoplay() {
    autoPlayInterval = setInterval(() => {
      let newIndex = (current + 1) % total;
      showSlide(newIndex);
    }, AUTO_PLAY_TIME);
  }

  function resetAutoplay() {
    clearInterval(autoPlayInterval);
    startAutoplay();
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      let newIndex = (current + 1) % total;
      showSlide(newIndex);
      resetAutoplay();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", function () {
      let newIndex = (current - 1 + total) % total;
      showSlide(newIndex);
      resetAutoplay();
    });
  }

  dots.forEach(dot => {
    dot.addEventListener("click", () => {
      const index = parseInt(dot.dataset.dot, 10);
      showSlide(index);
      resetAutoplay();
    });
  });

  // Inicializar
  showSlide(current);
  startAutoplay();
});
